import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { IS_NATIVE, OFFLINE_DIR } from "./lib/api";

const CDN = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}`;

// Native build renders fully offline from the bundled worker + fonts.
pdfjs.GlobalWorkerOptions.workerSrc = IS_NATIVE
  ? `${OFFLINE_DIR}/pdfjs/pdf.worker.min.mjs`
  : `${CDN}/build/pdf.worker.min.mjs`;

// Trim size of the source book (Field Edition, 6x9 in).
export const PAGE_ASPECT = 432 / 648; // width / height

export const pdfOptions = {
  cMapUrl: IS_NATIVE ? `${OFFLINE_DIR}/pdfjs/cmaps/` : `${CDN}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: IS_NATIVE ? `${OFFLINE_DIR}/pdfjs/standard_fonts/` : `${CDN}/standard_fonts/`,
};
